import React from 'react'
import RModal from 'react-modal'
import {LoadingPage} from 'components/ui/LoadingPage'
import styles from './SubmittingData.scss'

interface SubmittingDataProps {
  isSubmitting: boolean
}

export const SubmittingData: React.FC<SubmittingDataProps> = ({isSubmitting}) => {
  return (
    <RModal isOpen={isSubmitting} className={styles.submittingContent} overlayClassName={styles.submittingOverlay}>
      <LoadingPage />
      <p className={styles.submittingMessage}>
        データを送信しています
        <br />
        <span className={styles.danger}>画面を閉じたり移動しないでください</span>
      </p>
    </RModal>
  )
}
